import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { IFrameInfo } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { ITileDataShip, getStandard } from './tilesDataShip'
import { tileTiler } from './tileTiler-sidecar'

import chroma from 'chroma-js'
import { math } from '../engine/math-sidecar'

export type AsteroidType = '' | 'ice' | 'rock' | 'iron'

export interface ITileShip extends IEntity {
  x: number
  y: number
  i: number
  j: number
  imageStructure: Phaser.GameObjects.Image | null
  imageFloor: Phaser.GameObjects.Image | null
  imageShadow: Phaser.GameObjects.Image | null
  imageObject: Phaser.GameObjects.Image | null
  dataStructure: ITileDataShip | null
  dataFloor: ITileDataShip | null
  dataShadow: ITileDataShip | null
  dataObject: ITileDataShip | null
  asteroidType: AsteroidType
  asteroidheight: number
}

const objs: ITileShip[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function setStructure(tile: ITileShip, data: ITileDataShip | null) {
  if (data && !data.isStructure) {
    console.error('not structure!', data)
    return
  }
  tile.dataStructure = data
  tile.imageStructure = createTileImage(
    tile,
    layers.getLayers().shipStructure,
    data,
    tile.imageStructure,
  )
}

export function setFloor(tile: ITileShip, data: ITileDataShip | null) {
  if (data && !data.isFloor) {
    console.error('not floor!', data)
    return
  }
  tile.dataFloor = data
  tile.imageFloor = createTileImage(
    tile,
    layers.getLayers().shipFloor,
    data,
    tile.imageFloor,
  )
  if (tile.imageFloor) {
    tile.imageFloor.tint = 0xffffff // Reset to white
  }
  tileTiler.setDirty()
}

export function setAsteroidFloor(
  tile: ITileShip,
  asteroidHeight: number,
  asteroidType: AsteroidType,
) {
  let data = getStandard().asteroid
  tile.dataFloor = data
  tile.imageFloor = createTileImage(
    tile,
    layers.getLayers().shipFloor,
    data,
    tile.imageFloor,
  )
  tile.asteroidheight = asteroidHeight
  tile.asteroidType = asteroidType
  if (tile.imageFloor) {
    let iceColor = chroma('#c1d9f2')
    let rockColor = chroma('#9e5b47')
    let ironColor = chroma('#898989')
    let asteroidColor = rockColor
    let scale = 2
    if (asteroidType === 'ice') {
      asteroidColor = iceColor
      scale = 1
    }
    if (asteroidType === 'iron') {
      asteroidColor = ironColor
      scale = 2.5
    }

    let ah = math.clamp(asteroidHeight, 0.25, 1)
    //let min = 0.3
    //let p = asteroidHeight * (1 - min) + min

    asteroidColor = asteroidColor.darken((1 - ah) * scale)
    //let c = Math.floor(255 * p)
    //let tint = c + c * 256 + c * 256 * 256
    tile.imageFloor.tint = asteroidColor.num()
  }
  tileTiler.setDirty()
}

export function setTiledFloor(tile: ITileShip, fi: IFrameInfo) {
  assert.notNil(tile.imageFloor)
  spriteMap.setFrame(tile.imageFloor, fi)
}

export function setShadow(tile: ITileShip, data: ITileDataShip | null) {
  if (data && !data.isShadow) {
    console.error('not shadow!', data)
    return
  }
  tile.dataShadow = data
  tile.imageShadow = createTileImage(
    tile,
    layers.getLayers().shipShadow,
    data,
    tile.imageShadow,
  )
}

export function setObject(tile: ITileShip, data: ITileDataShip | null) {
  if (data && !data.isObject && !data.isDoor) {
    console.error('not object or door!', data)
    return
  }
  tile.dataObject = data
  tile.imageObject = createTileImage(
    tile,
    layers.getLayers().shipObject,
    data,
    tile.imageObject,
  )
}

export function createTileImage(
  tile: ITileShip,
  layer: Phaser.GameObjects.Container,
  data: ITileDataShip | null,
  currentImage: Phaser.GameObjects.Image | null,
) {
  if (!data) {
    if (currentImage) {
      currentImage.visible = false
    }
    return currentImage
  }

  if (currentImage) {
    spriteMap.setFrame(currentImage, data.frameInfo)
    currentImage.visible = true
    return currentImage
  }

  let image = spriteMap.createImageFromFrameInfo(
    layer,
    data.frameInfo,
    tile.x,
    tile.y,
  )

  return image
}

export function create(
  i: number,
  j: number,
  x: number,
  y: number,
  rotation: number = 0,
): ITileShip {
  let id = common.createId()

  let obj: ITileShip = {
    eType: 'tile-ship',
    id,
    isDead: false,
    imageShadow: null,
    imageStructure: null,
    imageFloor: null,
    imageObject: null,
    // imageMonster: null,
    dataShadow: null,
    dataStructure: null,
    dataFloor: null,
    dataObject: null,
    // dataMonster: 0,
    x,
    y,
    i,
    j,
    asteroidType: '',
    asteroidheight: 0,
  }
  objs.push(obj)

  return obj
}

export function kill(obj: ITileShip) {
  obj.isDead = true
}

export function killAll() {
  l.forEach(objs, (c) => {
    c.isDead = true
  })
}

export function updateAll() {
  // objs.forEach((c) => {
  //   update(c)
  // })
  entitiesUtils.removeDead(objs, (c) => {
    if (c.imageFloor) {
      c.imageFloor.destroy()
    }
    if (c.imageStructure) {
      c.imageStructure.destroy()
    }
    if (c.imageShadow) {
      c.imageShadow.destroy()
    }
    if (c.imageObject) {
      c.imageObject.destroy()
    }
  })
}
